<div id='modal-estatisticas' class="modal" aria-hidden="true" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalPopoversLabel">Estatísticas</h5>     
            </div>
            <div class="modal-body text-center">
                  <img src="assets/imgs/estatisticas.png">
                  <br>
                  <ul *ngFor="let item of infoStatistic">
                      <li>nao_fez_pedido: {{ item.nao_fez_pedido }}</li>
                      <li>faltou_bonificacao: {{ item.faltou_bonificacao }}</li>
                      <li>pdv_fechado: {{ item.pdv_fechado }}</li>
                      <li>demora_descarga: {{ item.demora_descarga }}</li>
                      <li>desacordo_comercial: {{ item.desacordo_comercial }}</li>
                      <li>prazo_errado: {{ item.prazo_errado }}</li>
                      <li>falta_nf: {{ item.falta_nf }}</li>
                      <li>nf_errada: {{ item.nf_errada }}</li>
                      <li>dificil_acesso: {{ item.dificil_acesso }}</li>
                  </ul>
            </div>
            <div class="modal-footer fixed-bottom">
                <button type="button" class="btn btn-secondary mr-auto" data-dismiss="modal"><i class="fa fa-times"></i> Fechar</button>
            </div>
        </div>
    </div>
</div>